// https://dummyjson.com/docs/products#products-all
const productSchema = {
  type: "object",
  properties: {
    products: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "integer" },
          title: { type: "string" },
          description: { type: "string" },
          category: { type: "string" },
          price: { type: "number" },
          discountPercentage: { type: "number" },
          rating: { type: "number" },
          stock: { type: "integer" },
          tags: {
            type: "array",
            items: { type: "string" },
          },
          brand: { type: "string" },
          sku: { type: "string" },
          weight: { type: "number" },
          dimensions: {
            type: "object",
            properties: {
              width: { type: "number" },
              height: { type: "number" },
              depth: { type: "number" },
            },
            required: ["width", "height", "depth"],
          },
          warrantyInformation: { type: "string" },
          shippingInformation: { type: "string" },
          availabilityStatus: { type: "string" },
          reviews: {
            type: "array",
            items: {
              type: "object",
              properties: {
                rating: { type: "integer" },
                comment: { type: "string" },
                date: { type: "string" },
                reviewerName: { type: "string" },
                reviewerEmail: { type: "string" },
              },
              required: ["rating", "comment", "date", "reviewerName"],
            },
          },
          returnPolicy: { type: "string" },
          minimumOrderQuantity: { type: "integer" },
          meta: {
            type: "object",
            properties: {
              createdAt: { type: "string" },
              updatedAt: { type: "string" },
              barcode: { type: "string" },
              qrCode: { type: "string" },
            },
            required: ["createdAt", "updatedAt", "barcode", "qrCode"],
          },
          thumbnail: { type: "string" },
          images: {
            type: "array",
            items: { type: "string" },
          },
        },
        required: [
          "id",
          "title",
          "description",
          "category",
          "price",
          "discountPercentage",
          "rating",
          "stock",
          "tags",
          "sku",
          "weight",
          "dimensions",
          "warrantyInformation",
          "shippingInformation",
          "availabilityStatus",
          "reviews",
          "returnPolicy",
          "minimumOrderQuantity",
          "meta",
          "thumbnail",
          "images",
        ],
      },
    },
    total: { type: "integer" },
    skip: { type: "integer" },
    limit: { type: "integer" },
  },
  required: ["products", "total", "skip", "limit"],
};

module.exports = { productSchema };
